import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

/**
 * A controller used to create new products on a catalogue
 */
export class CatalogueController {
  private static $inject = [
    '$state',
    'breadcrumbService',
    'ACTToolbarService',
    'catalogue'
  ];

  constructor(
    private $state: ng.ui.IStateService,
    private breadcrumbService: BreadcrumbService,
    private ActToolbarService: ACTToolbarService,
    private catalogue: InterACT.Interfaces.Catalogues.Catalogue
  ) {
    this.activate();
  }

  /**
   * Initialises the controller
   */
  private activate() {
    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'CATALOGUES',
        sref: 'catalogues.list'
      }, {
        name: `${this.catalogue.description} (version ${this.catalogue.version})`,
        sref: 'catalogue.dashboard',
        params: {
          catalogueId: this.catalogue.id,
          catalogueVersion: this.catalogue.version
        }
      }
    ]);
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle(this.catalogue.scheme.abbreviation);

      toolbar.setTabs([
        {
          label: 'HEADING.OVERVIEW',
          sref: 'catalogue.dashboard'
        },
        {
          label: 'PRODUCTS',
          sref: 'catalogue.product-list'
        },
        {
          label: 'CATALOGUE_HISTORY',
          labelShort: 'HISTORY',
          sref: 'catalogue.catalogue_history'
        },
        {
          label: 'CATALOGUE_VERSIONS',
          labelShort: 'VERSIONS',
          sref: 'catalogue.catalogue_versions'
        },
        {
          label: 'CATALOGUE_VALIDATION_ERRORS',
          labelShort: 'CATALOGUE_VALIDATION_ERRORS_SHORT',
          sref: 'catalogue.catalogue_notifications'
        }
      ], this.$state.current.data.selectedTab);
    });
  }
}